import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject} from 'rxjs';
import { LoginResponseModel } from '../models/LoginResponse.model';
import { AuthData } from '../models/auth-data.model';
import { BusinessService } from './business.service';
import { environment } from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class AuthenticationService {
  authChange = new Subject<boolean>();
  private isAuthenticated = false;


  constructor(private router: Router, private httpClient: HttpClient, private businessService: BusinessService) {
  }

  login(authData: AuthData): Observable<LoginResponseModel> {
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let postUrl = environment.apiUrl+'web/v2/staffLogin';
    return this.httpClient.post<LoginResponseModel>(postUrl,
      authData,
      {headers: headers});
  }

  checkValidSession(): Observable<LoginResponseModel> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
    return this.httpClient.get<LoginResponseModel>(`${environment.apiUrl}web/refreshSession?sessionToken=${localStorage.getItem('token')}`, {headers: headers});
  }

  logoutSuccessfully() {
    this.isAuthenticated = false;
    this.authChange.next(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentSessionId');
  }

  isAuth() {
    return this.isAuthenticated;
  }

  authenticatedSuccessfully(loginResponse: LoginResponseModel, routeToAm: boolean) {
    console.log('successfully authenticated');
    localStorage.setItem('token', loginResponse.loginToken);
    this.businessService.setConfigList(JSON.stringify(loginResponse.configList));
    this.businessService.setLoginResponse(loginResponse);
    this.isAuthenticated = true;
    this.authChange.next(true);
    if(routeToAm) {
      this.router.navigate(['account-management']);
    }
  }
}
